import { TKey } from '~/src/dash/publicaUI';

export enum EActiveFilter {
  SHOW_ALL = 0,
  INACTIVE,
  ACTIVE,
}

interface IStatusOption {
  label: string;
  value: number;
  message?: string;
  tKey: TKey;
}

export const statuses: IStatusOption[] = [
  { label: 'Active', value: EActiveFilter.ACTIVE, message: 'Showing Active Only', tKey: 'Active' },
  {
    label: 'Inactive',
    value: EActiveFilter.INACTIVE,
    message: 'Showing Inactive Only',
    tKey: 'Inactive',
  },
  { label: 'Show All', value: EActiveFilter.SHOW_ALL, message: 'Showing All', tKey: 'ShowAll' },
];
